import { BaseApiService, BaseFindDto, BaseFindOneDto } from "@remar/shared/dist/api/baseApiService";
import { CourseChapter } from "@remar/shared/dist/models";

import { CourseChapterCreateDto, CourseChapterDeleteDto, CourseChapterUpdateDto } from "./dto";

import { URLS } from "../services.constants";

export class CourseChaptersService extends BaseApiService<
	CourseChapter,
	CourseChapterCreateDto,
	BaseFindDto,
	BaseFindOneDto,
	CourseChapterUpdateDto,
	CourseChapterDeleteDto
> {
	constructor(baseUrl: string) {
		super(baseUrl);
	}
}

export const courseChaptersService = new CourseChaptersService(URLS.COURSE_CHAPTERS);
